<template>
  <div class="search-body">
    <div
      v-for="(value, key, i) in details_search"
      :key="i"
      class="search-button"
    >
      <my-Dropdown :index="i" :display="show_elem[i]" :my_key="key" :placeholder="$t(`filter.${key}`)" :value="value.values" :details_search="selected_filters[key]" @manage_display="manage_display" @select_filter="add_filter"></my-Dropdown>
    </div>
    <div class="chip-wrapper">
      <div v-for="filter in selected_filters" :key="filter" class="chip-container">
        <chip v-if="filter.name != null" :key="filter.name" :category="filter.name" :filter="$t(filter.name)" @remove_filter="remove_filter">
        </chip>
      </div>
    </div>
    <div v-show="loading" class="box-search-result">
      <div class="lds-dual-ring"></div>
    </div>
    <my-carousel
      v-if="carousel.values && !no_result"
      :like-dislike="false"
      :carousel="carousel"
    />
    <div v-else>
      <span style="display: block;
                  margin-top: 57px;
                  text-align-last: center;"
      >
        {{ this.$store.state.user.lang == "en" || this.$store.state.config.storeId == 41 ? "It seems that there is no maching product" : "Il ne semble pas y avoir d'article correspondant" }}
      </span>
    </div>
  </div>
</template>

<script>
import MyCarousel from "@/components/MyCarousel";
import Dropdown from "./Dropdown";
import chip from "./chip";
import { customLogger } from "@/utils";

export default {
  name: "Search",
  components: {
    "my-carousel": MyCarousel,
    "my-Dropdown": Dropdown,
    "chip": chip
  },
  data: () => {
    return {
      selected_filters: {},
      products: [],
      loading: false,
      no_result: false,
      show_elem: []
    };
  },
  computed: {
    carousel() {
      return {
        type: "products",
        values: this.products,
      };
    },
    details_search() {
      if (this.$store.state.config.details.search) {
        //add label fro the select options
        Object.values(this.$store.state.config.details.search).map((p) => {
          p.values.map((val) => {
            val.label = val.name;
          });
        });
        //////////////////////////////
        // customLogger(this.$store.state.config.details.search);
      }
      return this.$store.state.config.details.search;
    },
  },
  mounted() {
    // customLogger(this.$store.state.config.details);
    if (this.details_search) {
      Object.keys(this.details_search).forEach((key) => {
        this.selected_filters[key] = "";
        this.show_elem.push(false)
        // this.loading[key] = false;
      });
    }
    // customLogger(this.show_elem)
  },
  methods: {
    manage_display(index) {
      if (this.show_elem[index] === true) {
        this.show_elem[index] = !this.show_elem[index]
      } else {
        for (let i in this.show_elem) {
          this.show_elem[i] = false
        }
        this.show_elem[index] = !this.show_elem[index]
        // customLogger(this.show_elem)
      }
      this.$forceUpdate()
    },
    remove_filter(name) {
      for (const [key, value] of Object.entries(this.selected_filters)) {
        // customLogger(value)
        if (value.label === name)
          this.selected_filters[key] = ""
      }
      this.$forceUpdate()
      // customLogger("pass")
      this.filter_changed()
    },
    add_filter(key, filter) {
      this.selected_filters[key] = filter
      customLogger("add filter with key :", key,  this.selected_filters)
      this.filter_changed()
    },
    filter_changed() {

      customLogger('New filter :', this.selected_filters, this.carousel.values)
      var filters = {};
      this.no_result = false;
      // this.loading = [];
      for (const [key, value] of Object.entries(this.selected_filters)) {
        if (value) {
          customLogger("value", value);
          customLogger("key", key);
          if (Array.isArray(value)) {
            if (value.length) {
              //avoid the empty array in the filters
              filters[key] = value.map((v) => v.name.split(".")[1] || v.name);
              this.loading = true;
            } else this.selected_filters[key] = ""; //avoid the empty array in the filters
          } else {
            filters[key] = value.name.split(".")[1] || value.name;
            this.loading = true;
          }
        }
      }

      let pop = null
      //call the commit just if the filters are set
      if (this.$store.state.config.storeId == 33 || (this.$store.state.config.storeId == 49 && this.$store.state.navigation.mode == "your_mode")) {
        pop = store.state.config.steps[store.state.user.style_profile_key].carousel.popularity
      }
      if (Object.keys(filters).length) {
        customLogger("filters :", filters);
        this.$store
            .dispatch("GET_RECOMMENDATION", {
              number_products: 46,
              filters: filters,
              popularity: pop
            })
            .then((res) => {
              this.products = res;
              // customLogger("response", this.products);
              this.loading = false;
              if (!res) this.no_result = true;
            })
            .catch((err) => {
              // customLogger(err.message);
              this.loading = false;
            });
      } else this.products = [];
    },
  },
};
</script>
